// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ChatPage[data-v-05cc632c]{margin:0 auto;display:flex;flex-direction:column}.header[data-v-05cc632c]{height:100px;width:95%;display:flex;justify-content:flex-start;align-items:center;margin:15px 0 0 15px}.header_line[data-v-05cc632c]{width:100%;height:4px;background-color:#e2e8f0;z-index:1}.chatBox[data-v-05cc632c]{display:flex;flex-direction:column;width:670px;height:680px}", ""]);
// Exports
module.exports = exports;
